import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Divider, Menu, ScrollArea, Select, TextInput } from '@mantine/core';
import { Check } from 'tabler-icons-react';
import AppFlexbox from './AppFlexbox';
import AppStack from './AppStack';
import AppMenu from './AppMenu';
import AppText from './AppText';

const AppMenuSelect = ({ value, data, onChange, ...rest }) => {
  const [searchValue, setSearchValue] = useState('');

  const groupedData = data.reduce((acc, item) => {
    const group = item.section || 'Ungrouped';
    if (!acc[group]) {
      acc[group] = [];
    }
    acc[group].push(item);
    return acc;
  }, {});
  const hasSections = Object.keys(groupedData).length > 1;

  const selectedItem = data.find((item) => item.value === value);

  return (
    <AppMenu
      control={
        <Select
          searchValue={selectedItem?.label || ''}
          styles={{
            label: { fontWeight: 'normal' },
            input: {
              fontWeight: 'normal',
              fontFamily: selectedItem?.fontFamily
            }
          }}
          {...rest}
        />
      }
      position="bottom-start"
      styles={{ dropdown: { padding: 0 } }}
      width={300}
    >
      <AppStack style={{ gap: 0 }}>
        <AppFlexbox
          style={{
            gap: 8,
            padding: '8px 12px',
            alignItems: 'center'
          }}
        >
          <TextInput
            onChange={(e) => setSearchValue(e.currentTarget.value)}
            placeholder="Search..."
            style={{ flex: 1 }}
            value={searchValue || ''}
          />
        </AppFlexbox>
        <Menu.Divider style={{ margin: 0 }} />
        <ScrollArea.Autosize mah={350} scrollbarSize={5}>
          <AppStack style={{ gap: 3, padding: 3 }}>
            {Object.keys(groupedData).map((group) => (
              <AppStack key={group} style={{ gap: 3 }}>
                {hasSections && <Divider label={group} />}

                {groupedData[group]
                  .filter((f) =>
                    f.label.toLowerCase().includes(searchValue.toLowerCase())
                  )
                  .map((f) => (
                    <Menu.Item
                      key={f.value}
                      onClick={() => {
                        onChange(f.value);
                      }}
                    >
                      <AppFlexbox
                        style={{
                          alignItems: 'center',
                          justifyContent: 'space-between'
                        }}
                      >
                        <AppFlexbox style={{ alignItems: 'center' }}>
                          <AppText
                            style={{
                              fontSize: 14,
                              fontFamily: f.fontFamily
                            }}
                          >
                            {f.label}
                          </AppText>
                        </AppFlexbox>
                        {f.value === value && <Check color="#666" size={18} />}
                      </AppFlexbox>
                    </Menu.Item>
                  ))}
              </AppStack>
            ))}
          </AppStack>
        </ScrollArea.Autosize>
      </AppStack>
    </AppMenu>
  );
};

AppMenuSelect.propTypes = {
  data: PropTypes.array,
  onChange: PropTypes.func,
  value: PropTypes.string
};

export default AppMenuSelect;
